export enum CouponStatus {
  VALID = 'VALID',
  USED = 'USED',
  EXPIRED = 'EXPIRED',
  INACTIVE = 'INACTIVE',
  REMOVED = 'REMOVED',
}



// WEBPACK FOOTER //
// ./src/app/pages/coupons/enums/coupon-status.enum.ts